import { useCallback } from "react";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { getGaDataObject } from "@features/pulse/utils/helpers";
import { SanitizedPulseData } from "@features/pulse/utils/types";
import { getEnvironment } from "@util/constant";
import { getEnvironmentDomain } from "@util/helpers";
import posthog from "posthog-js";

/**
 * This hook is used to send Google Analytics data for Pulse articles.
 * It provides functions to send tracking data and custom events to Google Tag Manager.
 */
export default function useSendPulseGaData() {
  const sendDataToGTM = useGTMDispatch();

  const sendTrackingData = useCallback(
    (
      title: string,
      virtualUrl: string,
      articleId?: string,
      articles?: SanitizedPulseData[],
      pagination?: string,
      variant?: string
    ) => {
      const gaDataObject = getGaDataObject(
        title,
        virtualUrl,
        articleId,
        articles,
        pagination,
        variant
      );
      sendDataToGTM(gaDataObject);

      const currentUrl = getEnvironmentDomain(getEnvironment()) + virtualUrl;

      posthog.capture("$pageview", {
        $current_url: currentUrl,
      });
    },
    [sendDataToGTM]
  );

  const sendCustomEvent = useCallback(
    (eventAction: string, eventLabel: string) => {
      const trackingData = {
        event: "custom_event",
        eventCategory: "bt pulse",
        eventAction,
        eventLabel,
      };

      sendDataToGTM(trackingData);

      posthog.capture("custom_event", trackingData);
    },

    [sendDataToGTM]
  );

  return { sendTrackingData, sendCustomEvent };
}
